<div class="auth-card animate__animated animate__fadeIn">
  <div class="auth-card-header">
    <h2>Iniciar Sesión</h2>
  </div>

  <form [formGroup]="loginForm" (ngSubmit)="login()" class="auth-form">
    <div class="form-group">
      <label>Email</label>
      <div class="input-wrapper">
        <i class="fas fa-envelope input-icon"></i>
        <input
          formControlName="email"
          type="email"
          class="form-control"
          placeholder="tu@email.com"
          [class.is-invalid]="emailAccess"
        />
      </div>
      <small *ngIf="emailAccess" class="error-msg">Ingrese su correo electrónico</small>
    </div>

    <div class="form-group">
      <label>Contraseña</label>
      <div class="input-wrapper">
        <i class="fas fa-lock input-icon"></i>
        <input
          formControlName="password"
          [type]="showPasswordLogin ? 'text' : 'password'"
          class="form-control"
          placeholder="••••••••"
          [class.is-invalid]="passwordAccess"
        />
        <button type="button" class="toggle-password" (click)="showPasswordLogin = !showPasswordLogin">
          <i class="far" [ngClass]="showPasswordLogin ? 'fa-eye-slash' : 'fa-eye'"></i>
        </button>
      </div>
      <small *ngIf="passwordAccess" class="error-msg">Ingrese su contraseña</small>
    </div>

    <div class="auth-actions">
      <a routerLink="/resend-pin" class="link-secondary">Reenviar PIN</a>
      <a routerLink="/forgot-password" class="link-secondary">¿Olvidaste tu contraseña?</a>
    </div>

    <button type="submit" class="btn-primary" [disabled]="!loginForm.valid || (spinnerService.spinner$ | async)?.show">
      <span *ngIf="!(spinnerService.spinner$ | async)?.show"><i class="fas fa-sign-in-alt"></i> Iniciar Sesión</span>
      <span *ngIf="(spinnerService.spinner$ | async)?.show"><i class="fas fa-spinner fa-spin"></i> Ingresando...</span>
    </button>

    <div *ngIf="googleLoginActivo" class="google-separator">
      <span>o continuar con</span>
    </div>

    <button *ngIf="googleLoginActivo" type="button" class="btn-google" (click)="loginWithGoogle()">
      <img src="assets/img/google-icon.png" alt="Google" width="20" />
      Google
    </button>

    <div class="auth-footer">
      <p>¿No tenés cuenta? <a routerLink="/register" class="link-highlight">Crear Cuenta</a></p>
    </div>
  </form>
</div>
